// ============================================
// Auth - Splash Module (ES6)
// 스플래시 화면 애니메이션 - 모던 다크 테마
// ============================================

import { getCurrentUser } from '../app/state.js';

// ============================================
// State
// ============================================

let glowTimeout = null;
let initialized = false;
let animationFrameId = null;
let particles = [];
let canvas = null;
let ctx = null;

// ============================================
// Particle System
// ============================================

function createParticle() {
  const isGold = Math.random() > 0.3;
  return {
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    size: Math.random() * 2 + 0.5,
    speedX: (Math.random() - 0.5) * 0.3,
    speedY: (Math.random() - 0.5) * 0.3,
    opacity: Math.random() * 0.5 + 0.2,
    pulse: Math.random() * Math.PI * 2,
    pulseSpeed: Math.random() * 0.02 + 0.01,
    isGold: isGold
  };
}

function initParticles() {
  canvas = document.getElementById('particleCanvas');
  if (!canvas) return;

  ctx = canvas.getContext('2d');

  // Canvas 크기 설정
  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  // 파티클 생성
  const particleCount = Math.min(80, Math.floor(window.innerWidth / 15));
  particles = [];
  for (let i = 0; i < particleCount; i++) {
    particles.push(createParticle());
  }

  // 애니메이션 시작
  animateParticles();
}

function animateParticles() {
  if (!ctx || !canvas) return;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  particles.forEach(p => {
    // 위치 업데이트
    p.x += p.speedX;
    p.y += p.speedY;
    p.pulse += p.pulseSpeed;

    // 화면 밖으로 나가면 반대편에서 등장
    if (p.x < 0) p.x = canvas.width;
    if (p.x > canvas.width) p.x = 0;
    if (p.y < 0) p.y = canvas.height;
    if (p.y > canvas.height) p.y = 0;

    // 펄스 효과로 opacity 변화
    const currentOpacity = p.opacity * (0.7 + 0.3 * Math.sin(p.pulse));

    // 그라데이션으로 파티클 그리기
    const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 2);

    // 금색/보라색
    if (p.isGold) {
      gradient.addColorStop(0, `rgba(212, 175, 55, ${currentOpacity})`);
      gradient.addColorStop(1, `rgba(212, 175, 55, 0)`);
    } else {
      gradient.addColorStop(0, `rgba(139, 92, 246, ${currentOpacity})`);
      gradient.addColorStop(1, `rgba(139, 92, 246, 0)`);
    }

    ctx.beginPath();
    ctx.arc(p.x, p.y, p.size * 2, 0, Math.PI * 2);
    ctx.fillStyle = gradient;
    ctx.fill();
  });

  animationFrameId = requestAnimationFrame(animateParticles);
}

// ============================================
// Splash Animation
// ============================================

export function initSplashAnimation() {
  if (initialized) return;
  initialized = true;

  // 파티클 애니메이션 초기화
  initParticles();

  // 브랜드 텍스트에 글로우 효과 추가 (애니메이션 완료 후)
  const brandText = document.getElementById('brandText');
  if (brandText) {
    glowTimeout = setTimeout(() => {
      brandText.classList.add('glow-active');
    }, 2000);
  }
}

// ============================================
// 정리 함수
// ============================================

export function stopSplashAnimation() {
  if (glowTimeout) {
    clearTimeout(glowTimeout);
    glowTimeout = null;
  }

  if (animationFrameId) {
    cancelAnimationFrame(animationFrameId);
    animationFrameId = null;
  }

  particles = [];
  canvas = null;
  ctx = null;
  initialized = false;
}

// ============================================
// Splash Auth
// ============================================

export function showSplashAuth() {
  console.log('[Splash] showSplashAuth called');
  const splashScreen = document.getElementById('splashScreen');
  const authEl = document.getElementById('splashAuth');

  if (authEl) {
    authEl.style.display = 'flex';
  }

  requestAnimationFrame(() => {
    if (splashScreen) {
      splashScreen.classList.add('auth-visible');
    }
  });

  initSplashAnimation();
}

export function hideSplashAuth() {
  const splashScreen = document.getElementById('splashScreen');
  const authEl = document.getElementById('splashAuth');

  if (splashScreen) {
    splashScreen.classList.remove('auth-visible');
  }

  if (authEl) {
    authEl.style.display = 'none';
  }
  stopSplashAnimation();
}
